import { FormItem } from '../../../../commons/Form/Form.types';
import { InitPasswordFormSchema } from './InitPasswordForm.types';

export const registerSignUpStepData: FormItem<InitPasswordFormSchema>[][] = [
  [
    {
      name: 'email',
      placeholder: 'Votre adresse email...',
      label: 'Adresse email',
      type: 'text',
      required: true,
      disabled: true,
    },
  ],
  [
    {
      name: 'password',
      placeholder: 'Votre mot de passe...',
      label: 'Mot de passe',
      type: 'password',
      required: true,
    },
    {
      name: 'passwordConfirmation',
      placeholder: 'Confirmez votre mot de passe...',
      label: 'Confirmation du mot de passe',
      type: 'password',
      required: true,
    },
  ],
];
